import React from 'react'

function Department() {
  return (
    <div>
   
    </div>
  )
}

export default Department;
